import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";


const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getFeedUrl = (source = "all") => {
  const query = source === "all" ? "" : `?source=${source}`;
  return `${API_BASE}/newsfeed${query}`;
};

const fetchSiteOverview = async () => {
  const response = await axios.get(`${API_BASE}/site`);
  return response.data;
};

const fetchNewsfeed = async (source) => {
  const response = await axios.get(getFeedUrl(source));
  return response.data;
};

export const useNewsroomData = () => {
  const [siteData, setSiteData] = useState(null);
  const [feed, setFeed] = useState([]);
  const [selectedSource, setSelectedSource] = useState("all");
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  const loadSite = useCallback(async () => {
    const data = await fetchSiteOverview();
    setSiteData(data);
  }, []);

  const loadFeed = useCallback(async (source = "all") => {
    const data = await fetchNewsfeed(source);
    setFeed(data);
  }, []);

  const loadAll = useCallback(async (source) => {
    setLoading(true);
    try {
      await Promise.all([loadSite(), loadFeed(source)]);
    } catch {
      toast.error("The newsroom feed could not load.");
    } finally {
      setLoading(false);
    }
  }, [loadFeed, loadSite]);

  useEffect(() => {
    loadAll(selectedSource);
  }, [loadAll, selectedSource]);

  const refreshNewsroom = useCallback(async () => {
    try {
      setRefreshing(true);
      await axios.post(`${API_BASE}/sync/refresh`);
      await Promise.all([loadSite(), loadFeed(selectedSource)]);
      toast.success("Newsroom refreshed.");
    } catch {
      toast.error("Refresh did not complete.");
    } finally {
      setRefreshing(false);
    }
  }, [loadFeed, loadSite, selectedSource]);

  return {
    siteData,
    feed,
    selectedSource,
    setSelectedSource,
    loading,
    refreshing,
    refreshNewsroom,
  };
};